import { render, staticRenderFns } from "./NflPositionOpti.vue?vue&type=template&id=dd9d67ee&scoped=true"
import script from "./NflPositionOpti.vue?vue&type=script&lang=js"
export * from "./NflPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NflPositionOpti.vue?vue&type=style&index=0&id=dd9d67ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d67ee",
  null
  
)

export default component.exports